module.exports = __webpack_public_path__ + "static/img/16.983e435.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/3/16.png
// module id = H21g
// module chunks = 0